export default "__VITE_ASSET___89eFZbd__"